module.exports = __webpack_public_path__ + "70826a7a6b3b22fe04facbeefb317891.MP3";